<template>
  <div class="search">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">Enumeration / Search</v-card-title>
      <v-card-text>
        <div class="controlbar" v-if="showcontrolbar == true">
          <font-awesome-icon class="search_icon" icon="search" /><br />
          <font-awesome-icon
            class="down"
            icon="chevron-down"
            @click="ShowSearchControl"
          />
        </div>
        <div class="search_ctrl" v-if="showsearchcontrol == true">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="form_item">
                <!-- <v-text-field
                  v-model="email"
                  label="E-mail"
                  type="email"
                  class="input_item"
                  :rules="emailRule"
                  @change="ChangeChipEmail"
                  hint="E-mail"
                  persistent-hint
                >
                </v-text-field> -->
                <v-text-field
                  v-model="description"
                  label="Description"
                  type="text"
                  class="input_item"
                  @change="ChangeChipDescription"
                  hint="Description"
                  persistent-hint
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="form_item">
                <v-text-field
                  v-model="street"
                  label="Street"
                  type="text"
                  class="input_item"
                  @change="ChangeChipStreet"
                  hint="Street"
                  persistent-hint
                >
                </v-text-field>
                <v-text-field
                  v-model="city"
                  label="City"
                  type="text"
                  class="input_item"
                  @change="ChangeChipCity"
                  hint="City"
                  persistent-hint
                >
                </v-text-field>
                <v-text-field
                  v-model="country"
                  label="Country"
                  type="text"
                  class="input_item"
                  @change="ChangeChipCountry"
                  hint="Country"
                  persistent-hint
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="form_item">
                <v-text-field
                  v-model="ipaddress"
                  label="IP Address"
                  type="text"
                  class="input_item"
                  @change="ChangeChipIp"
                  hint="IP Address"
                  persistent-hint
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="form_item">
                <v-text-field
                  v-model="vendor"
                  label="Vendor"
                  type="text"
                  class="input_item"
                  @change="ChangeChipVendor"
                  hint="Vendor"
                  persistent-hint
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="table_container" v-if="showcontrolbar == true">
          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-footer
            :disable-pagination="true"
            item-key="id"
          >
            <template v-slot:item.index="{ item }">
              <div class="not_mobile">
                <span>{{ item.index }}</span>
              </div>
              <div class="mobile">
                <div>
                  <span>{{ item.index }}</span>
                  <span>{{ item.description }}</span>
                </div>
                <span>{{ item.vendor }}</span>
              </div>
            </template>
            <template v-slot:item.ipaddress="{ item }">
              <div class="not_mobile">
                <span>{{ item.ipaddress }}</span>
              </div>
              <div class="mobile">
                <span>{{ item.ipaddress }}</span>
                <div>
                  <p>{{ item.city }}</p>
                  <p>{{ item.country }}</p>
                </div>
              </div>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <paginate
              :page-count="pageCount"
              :click-handler="checkPage"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
            >
            </paginate>
          </div>
        </div>
      </v-card-text>
      <div class="result">
        <div class="number">
          <p v-if="showcontrolbar == true">
            Found <span class="bold">{{ this.resultnumber }} results</span>
          </p>
          <span class="tagItem">
            <v-chip
              v-if="chip_description"
              class="ma-2"
              close
              @click:close="chip_email = false"
              >Description</v-chip
            >
            <v-chip
              v-if="chip_street"
              class="ma-2"
              close
              @click:close="chip_street = false"
              >Street</v-chip
            >
            <v-chip
              v-if="chip_city"
              class="ma-2"
              close
              @click:close="chip_city = false"
              >City</v-chip
            >
            <v-chip
              v-if="chip_country"
              class="ma-2"
              close
              @click:close="chip_country = false"
              >Country</v-chip
            >
            <v-chip
              v-if="chip_ip"
              class="ma-2"
              close
              @click:close="chip_ip = false"
              >IP Address</v-chip
            >
            <v-chip
              v-if="chip_vendor"
              class="ma-2"
              close
              @click:close="chip_vendor = false"
              >Vendor</v-chip
            >
          </span>
        </div>
        <div class="button_group">
          <v-btn class="_search" color="#2bb9aa" @click="searchBuilding"
            >SEARCH</v-btn
          >
          <v-btn class="clear" @click="InitalizeInput">CLEAR</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
export default {
  data() {
    return {
      description: "",
      email: "",
      street: "",
      city: "",
      country: "",
      ipaddress: "",
      vendor: "",
      fieldRules: [v => !!v || "Required"],
      showsearchcontrol: true,
      showcontrolbar: false,
      headers: [
        { text: "No", align: "center", sortable: false, value: "index" },
        {
          text: "DESCRIPTION",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "IP ADDRESS",
          align: "center",
          sortable: false,
          value: "ipaddress"
        },
        { text: "VENDOR", align: "center", sortable: false, value: "vendor" },
        { text: "CITY", align: "center", sortable: false, value: "city" },
        { text: "COUNTRY", align: "center", sortable: false, value: "country" }
      ],
      chip_description: false,
      chip_email: false,
      chip_street: false,
      chip_city: false,
      chip_country: false,
      chip_ip: false,
      chip_vendor: false,
      emailRule: [
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Invalid e-mail.";
        }
      ],
      page: 1,
      limit: 10,
      pageCount: 0,
      items: []
    };
  },
  mounted() {},
  computed: {
    // items() {
    //     return this.$store.state.enumeration.searchresult;
    // },
    resultnumber() {
      return this.$store.getters.resultnumber;
    }
  },
  methods: {
    ShowSearchControl() {
      this.showsearchcontrol = this.showsearchcontrol == true ? false : true;
      if (this.showsearchcontrol == true) {
        let itag = document.querySelector(".controlbar .down");
        itag.style.transform = "rotate(180deg)";
        itag.style.transition = "all 0.6s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      } else {
        let itag = document.querySelector(".controlbar .down");
        itag.style.transform = "none";
        itag.style.transition = "all 0.6s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      }
    },
    ChangeChipDescription() {
      this.chip_description = this.description == "" ? false : true;
    },
    ChangeChipEmail() {
      this.chip_email = this.email == "" || this.emailRule ? false : true;
    },
    ChangeChipStreet() {
      this.chip_street = this.street == "" ? false : true;
    },
    ChangeChipCity() {
      this.chip_city = this.city == "" ? false : true;
    },
    ChangeChipCountry() {
      this.chip_country = this.country == "" ? false : true;
    },
    ChangeChipIp() {
      this.chip_ip = this.ipaddress == "" ? false : true;
    },
    ChangeChipVendor() {
      this.chip_vendor = this.vendor == "" ? false : true;
    },
    InitalizeInput() {
      // initialize the input value
      this.description = "";
      this.email = "";
      this.street = "";
      this.city = "";
      this.country = "";
      this.ipaddress = "";
      this.vendor = "";
      // initialize the chip
      this.chip_description = "";
      this.chip_email = "";
      this.chip_street = "";
      this.chip_city = "";
      this.chip_country = "";
      this.chip_ip = "";
      this.chip_vendor = "";

      this.items = [];
      this.showcontrolbar = false;
    },
    searchBuilding() {
      if (
        !this.description &&
        !this.street &&
        !this.city &&
        !this.country &&
        !this.ipaddress &&
        !this.vendor
      ) {
        return;
      }
      this.$store
        .dispatch("searchBuilding", {
          description: this.description,
          street: this.street,
          city: this.city,
          country: this.country,
          ip: this.ipaddress,
          vendor: this.vendor,
          page: this.page,
          limit: this.limit
        })
        .then(response => {
          this.paginationUpdate(response.data);
        });
    },
    checkPage(pageNum) {
      this.page = pageNum;
      this.$store
        .dispatch("searchBuilding", {
          description: this.description,
          street: this.street,
          city: this.city,
          country: this.country,
          ip: this.ipaddress,
          vendor: this.vendor,
          page: this.page,
          limit: this.limit
        })
        .then(response => {
          this.paginationUpdate(response.data);
        });
    },
    paginationUpdate(data) {
      this.showcontrolbar = true;
      this.pageCount = data.total_pages;
      let current_page = data.current_page;
      this.items = data.data.map((item, index) => ({
        index: (current_page - 1) * 10 + index + 1,
        id: item.id,
        description: item.description,
        ipaddress: item.ipaddress,
        vendor: item.vendor,
        city: item.city,
        country: item.country,
        location: item.location,
        source: item.soucre,
        latitude: item.latitude,
        longitude: item.longitude,
        upload: item.upload
      }));
    }
  }
};
</script>
